__turbopack_context__.v({
  "detailSection": "RIhOXW_detailSection",
  "detailSectionContent": "RIhOXW_detailSectionContent",
  "layoutWithSidebar": "RIhOXW_layoutWithSidebar",
  "linkedAccosLayout": "RIhOXW_linkedAccosLayout",
  "priceTableSection": "RIhOXW_priceTableSection",
  "priceTableSectionVisible": "RIhOXW_priceTableSectionVisible",
  "promotedPriceSection": "RIhOXW_promotedPriceSection",
  "recommendedAccosLayoutLegacy": "RIhOXW_recommendedAccosLayoutLegacy",
  "wrapper": "RIhOXW_wrapper",
});
